"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowEvent = void 0;
var react_1 = require("react");
function useWindowEvent(type, listener, options) {
    react_1.useEffect(function () {
        window.addEventListener(type, listener, options);
        return function () { return window.removeEventListener(type, listener, options); };
    }, []);
}
exports.useWindowEvent = useWindowEvent;
